// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"225":"very-logo","305":"ocean-logo","467":"ASOS-logo","638":"capital-one-logo","749":"littlewoods-logo","766":"think-money-logo","908":"luma-logo"}[chunkId] + "." + {"225":"affaec7d","305":"1e62fea2","467":"9e365ca2","638":"2897a1d5","749":"3e980a1a","766":"23ebef5d","908":"20fa046a"}[chunkId] + ".chunk.js";
};